/**
 * Forces a full page reload to /sign-in
 * This is necessary to ensure IP restrictions configured at the infrastructure level are applied.
 * Using React Router's navigate() would bypass these restrictions with a client-side navigation.
 */
export function redirectToSignIn(): void {
  window.location.replace('/sign-in');
}
